import type { SVGProps } from 'react';
const SvgTakeoutDining = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#takeout_dining_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.26 11h13.48l-.67 9H5.93l-.67-9Zm3.76-7h5.95L19 7.38l1.59-1.59L22 7.21 19.21 10H4.79L2 7.21 3.41 5.8 5 7.38 9.02 4Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="takeout_dining_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTakeoutDining;
